import React, { useState, useRef } from 'react';
import styles from './LanguageSelect.module.scss';
import cx from 'classnames';
import useOutsideClick from '../../../../hooks/useOutsideClick';
import Images from '../../../../constants/Images';
import LanguageItem from '../LanguageItem/LanguageItem';
import { useTranslation } from 'react-i18next';

const LanguageSelect = ({
  title = '',
  options,
  onSelect,
  currentlySelected,
  className,
  listClassName,
  listItemClassName,
  selectedItemClassName,
}) => {
  const [showOptions, setShowOption] = useState(false);

  const { t } = useTranslation();

  const handleSelect = option => {
    onSelect(option);
    setShowOption(false);
  };

  const toggleSelection = () => setShowOption(prevState => !prevState);

  const selectRef = useRef(null);
  useOutsideClick(selectRef, () => {
    if (showOptions) {
      setShowOption(false);
    }
  });

  return (
    <div className={cx(styles.selectWrapper, className)}>
      {title && <p className={styles.selectTitle}>{title}</p>}
      <div className={styles.selectInput}>
        {currentlySelected ? (
          <LanguageItem
            name={t(currentlySelected.name)}
            src={currentlySelected.src}
            iconClassName={styles.currentLanguageIcon}
            className={cx({ [selectedItemClassName]: !currentlySelected.src })}
          />
        ) : (
          '-'
        )}
        <div onClick={toggleSelection} className={styles.buttonWrapper}>
          <img src={Images.ArrowDownIcon} className={cx(styles.arrowButton, { [styles.turnArrow]: showOptions })} alt={t('accessibility.arrow_down')} />
        </div>
      </div>
      {showOptions && (
        <ul className={cx(styles.customSelectContainer, listClassName)} ref={selectRef}>
          {options.map(option => (
            <li className={styles.option} key={option.id} onClick={() => handleSelect(option)}>
              <LanguageItem name={t(option.name)} src={option.src} className={cx({ [listItemClassName]: !option.src })} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelect;
